import {Deal} from "@irati/types"

const hasPerksGOLocations = (deal: Deal) => {
  return (!!deal?.isInStoreDeal)
}

export default hasPerksGOLocations
